import React, { useEffect } from "react";
import { useFormattedMessage, useSideModalScrollToTop, useUtils } from "hooks";
import LottiePlayer from "components/LottiePlayer";
import successIcon from "assets/images/success-icon.json";
import NavLink from "components/NavLink";

import { WEB_FLOW_ROUTES } from "constants/index";
import { connect } from "react-redux";
import { fetchUserDetailsStart } from "store/user/account/actions";

const messages = {
    title: "successful",
    ewalletTitle: "ewallet_ready_to_use",
    smWaitingContent: "waiting_for_activation",
    smHeading: "ewallet_secondary_ready",
    fwHeading: "your_ewallet_ready",
    fwContent: "overview_deposit_investments_withdrawals",
    fwPointOne: "ewallet_credit_account",
    fwPointTwo: "own_iban",
    fwPointThree: "access_funds_to_invest",
    fwPointFour: "withdraw_balance_any_time",
    fwButtonText: "pay_in_credit_now",
    fwBottomLine: "more_about_ewallet",
    knowledgeBaseLinkText: "knowledge_base_link",
};

const EwalletSuccess = ({ backSlideEffect = "", setBackSlideEffect, setStep, fetchUserDetailsStart }) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();
    const isTenantFinexity = useUtils().isTenantFinexity;

    useEffect(() => {
        setTimeout(() => fetchUserDetailsStart(), 500);
    }, []);

    return (
        <div className={`mb-20 ${backSlideEffect}`}>
            <div className="bg-dark p-21 text-center">
                <LottiePlayer autoplay loop={false} keepLastFrame speed={1} src={successIcon} style={{ maxWidth: 80 }} />
                <span className="d-inline-block text-18 mt-3">{formatMessage(messages.ewalletTitle)}</span>
            </div>
            <div className="px-5">
                <h3 className="mt-8">{formatMessage(messages.fwHeading)}</h3>
                <p className="text-16">{formatMessage(messages.fwContent)}</p>
                <div className="my-10">
                    <div className="d-flex align-start">
                        <i className="text-22 line-height-initial mr-5 fas fa-check-circle primary-color" />
                        <p className="text-16">{formatMessage(messages.fwPointOne)}</p>
                    </div>
                    <div className="d-flex align-start">
                        <i className="text-22 line-height-initial mr-5 fas fa-check-circle primary-color" />
                        <p className="text-16">{formatMessage(messages.fwPointTwo)}</p>
                    </div>
                    <div className="d-flex align-start">
                        <i className="text-22 line-height-initial mr-5 fas fa-check-circle primary-color" />
                        <p className="text-16">{formatMessage(messages.fwPointThree)}</p>
                    </div>
                    <div className="d-flex align-start">
                        <i className="text-22 line-height-initial mr-5 fas fa-check-circle primary-color" />
                        <p className="text-16">{formatMessage(messages.fwPointFour)}</p>
                    </div>
                </div>
                <button
                    className="mb-12"
                    onClick={() => {
                        setStep("walletOverview");
                        setBackSlideEffect("step-slide-left");
                    }}
                >
                    {formatMessage(messages.fwButtonText)}
                </button>
                {isTenantFinexity && (
                    <p className="text-16">
                        {formatMessage(messages.fwBottomLine)}
                        <NavLink isExternal className="primary-color" href={WEB_FLOW_ROUTES.KNOWLEDGE_BASE}>
                            {formatMessage(messages.knowledgeBaseLinkText)}
                        </NavLink>
                    </p>
                )}
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserDetailsStart: () => dispatch(fetchUserDetailsStart()),
});

export default connect(null, mapDispatchToProps)(EwalletSuccess);
